export const menuData = [
  {
    dan: "Ponedjeljak",
    date: "03.03",
    jelo: "Gurmanska pljeskavica sa sirom",
    dodaci: "+ pommes + 1/2 lepinje + umak",
    price: "7.50€",
  },
  {
    dan: "Utorak",
    date: "04.03",
    jelo: "Bečki odrezak",
    dodaci: "+ restani krumpir + tartarski umak",
    price: "7.50€",
  },
  {
    dan: "Srijeda",
    date: "05.03",
    jelo: "Rižoto s piletinom",
    dodaci: "+ miješana salata",
    price: "7.50€",
  },
  // ... dodaj ostale dane
];
